<div class="fn-ui-empty-icon">
    <app-fn-ui-icon icon="no-results" size="50px"></app-fn-ui-icon>
</div>